module.exports = __webpack_public_path__ + "static/media/BackgroundBadOptimized.3bddbf78.jp2";